import React from 'react';
import { PageContainer } from '../../components/container/PageContainer';
import { UpcomingCoursesIframe } from '../iframe/UpcomingCoursesIframe';

interface CurrentWeekPageProps {}

export const CurrentWeekPage: React.FC<CurrentWeekPageProps> = () => (
  <PageContainer isHeader={true}>
    <UpcomingCoursesIframe />
  </PageContainer>
);
